module.exports = {"Administración de tipos de comprobantes":"Administración de tipos de comprobantes","Listado de tipos de comprobantes":"Listado de tipos de comprobantes","Ver tipo de comprobante":"Ver tipo de comprobante","Editar tipo de comprobante":"Editar tipo de comprobante","Nuevo tipo de comprobante":"Nuevo tipo de comprobante","Acción":"Acción","Clase":"Clase","Condición de Venta":"Condición de Venta","Nombre":"Nombre","¿Genera cuotas?":"¿Genera cuotas?"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/tipos-comprobantes/es.json
// module id = 1105
// module chunks = 0